import { create } from "zustand";

interface MenuState {
  activeMenuId: string | null;
  setActiveMenuId: (id: string | null) => void;
}

export const useMenuStore = create<MenuState>((set) => ({
  activeMenuId: null,
  setActiveMenuId: (id) => set({ activeMenuId: id }),
}));